import React from "react";
import { createRoot } from "react-dom/client";
import SwiperMain from "./swiper";

const App = () => {
  return <SwiperMain />;
};

export default App;

const rootElement = document.querySelector(".tours-custom-swiper");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
